/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./short-link.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./short-link.component";
var styles_ShortLinkComponent = [i0.styles];
var RenderType_ShortLinkComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_ShortLinkComponent, data: {} });
export { RenderType_ShortLinkComponent as RenderType_ShortLinkComponent };
export function View_ShortLinkComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "p", [], null, null, null, null, null)), (_l()(), i1.ɵted(-1, null, ["short-link works!"]))], null, null); }
export function View_ShortLinkComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "sc-short-link", [], null, null, null, View_ShortLinkComponent_0, RenderType_ShortLinkComponent)), i1.ɵdid(1, 114688, null, 0, i2.ShortLinkComponent, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var ShortLinkComponentNgFactory = i1.ɵccf("sc-short-link", i2.ShortLinkComponent, View_ShortLinkComponent_Host_0, {}, {}, []);
export { ShortLinkComponentNgFactory as ShortLinkComponentNgFactory };
